import { render, staticRenderFns } from "./scrotalIndividual.vue?vue&type=template&id=9cf2f86a&scoped=true&"
import script from "./scrotalIndividual.vue?vue&type=script&lang=js&"
export * from "./scrotalIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf2f86a",
  null
  
)

export default component.exports